const faqs = [
  { q: '番茄影视大全真的完全免费吗？', a: '是的，番茄影视大全所有内容完全免费观看。无需注册账号、无需购买会员、无需任何付费，打开网站即可直接播放高清影视内容。我们通过广告收入维持运营，不向用户收取任何费用。' },
  { q: '看视频需要安装播放器或插件吗？', a: '不需要。番茄影视大全采用HTML5原生播放技术，无需安装任何播放器、插件或App。使用主流浏览器（Chrome、Safari、Edge等）访问即可直接播放，手机、平板、电脑均可兼容。' },
  { q: '视频画质怎么样？会不会卡顿？', a: '我们提供高清画质播放，大部分内容支持720P和1080P清晰度。平台采用智能CDN加速和多线服务器架构，在中国大陆及海外大部分地区均可流畅播放、不缓冲。实际体验取决于您的网络环境。' },
  { q: '剧集更新速度快吗？', a: '非常快。我们的内容团队7×24小时监测全网更新动态，热门剧集通常在播出后24小时内完成上线。国产剧、日漫等热门内容基本能做到与播出平台同步更新。' },
  { q: '可以在手机上观看吗？', a: '完全可以。番茄影视大全采用响应式设计，完美适配手机、平板和电脑。在手机浏览器中访问即可以移动端优化的界面观影，支持全屏播放、手势调节亮度和音量。无需下载App。' },
  { q: '遇到无法播放或有版权问题怎么办？', a: '如果遇到播放问题，可以尝试刷新页面或切换播放线路。如发现侵权内容或内容有误，请通过版权反馈邮箱 copyright@fanqieys.com 联系我们，我们会第一时间处理。' },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于番茄影视大全的使用问题，这里有你想要的答案
          </p>
        </div>

        <div className="flex flex-col gap-3 md:gap-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-2xl p-5 md:p-6 bg-background-50 border border-background-200/70 hover:border-primary-100 transition-all duration-300"
            >
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 mt-0.5 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-600">Q</span>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-9">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}